export default __webpack_public_path__ + "static/media/main_store_entry.830b0131.svg";